import React from "react";
import "./Banner.css";
import axios from "axios";

function Banner() {
  return (
    <section className="Banner">
      <div className="container-fluid p-0">
        <div className="banner_holder">
          <img
            src="/assets/images/home/banner/home_banner.png"
            className="ready_banner"
          />
        </div>
      </div>
    </section>
  );
}

export default Banner;
